import blog1 from "../images/blog/blog1.png";
import blog2 from "../images/blog/blog2.png";
import blog3 from "../images/blog/blog3.png";
import blog4 from "../images/blog/blog4.png";
import blog5 from "../images/blog/blog5.png";
import blog6 from "../images/blog/blog6.png";
import blog7 from "../images/blog/blog7.png";
import blog8 from "../images/blog/blog8.png";
export const blogs = [
  {
    id: 1,
    img: blog1,
    title: "Our Success Story",
    text: "How knoct become the leading identity verification platform within 6 months of launch",
    date: "19 March 2020",
    link: "#",
  },
  {
    id: 2,
    img: blog2,
    title: "Making it Work",
    text: "How knoct become the leading identity verification platform within 6 months of launch",
    date: "19 March 2020",
    link: "#",
  },
  {
    id: 3,
    img: blog3,
    title: "Our Api Stack",
    text: "How knoct become the leading identity verification platform within 6 months of launch",
    date: "19 March 2020",
    link: "#",
  },
  {
    id: 4,
    img: blog4,
    title: "Going Global",
    text: "How knoct become the leading identity verification platform within 6 months of launch",
    date: "19 March 2020",
    link: "#",
  },
  {
    id: 5,
    img: blog5,
    title: "How to create a productive team ?",
    text: "How knoct become the leading identity verification platform within 6 months of launch",
    date: "19 March 2020",
    link: "#",
  },
  {
    id: 6,
    img: blog6,
    title: "Why Now ?",
    text: "How knoct become the leading identity verification platform within 6 months of launch",
    date: "19 March 2020",
    link: "#",
  },
  {
    id: 7,
    img: blog7,
    title: "Here is how we collabrate",
    text: "How knoct become the leading identity verification platform within 6 months of launch",
    date: "19 March 2020",
    link: "#",
  },
  {
    id: 8,
    img: blog8,
    title: "Our APIs",
    text: "How knoct become the leading identity verification platform within 6 months of launch",
    date: "19 March 2020",
    link: "#",
  },
];
